import listTemplate from './list/list.pug';
import formTemplate from './form/form.pug';
import viewTemplate from './view/view.pug';

'use strict';

export default ['$stateProvider', function routes($stateProvider) {
  $stateProvider
    .state('group.memberView.memberTransaction', {
    // /context/:ctxId/groups/:groupId/membertransactions
    // :ctxId = ancestor/context group, :groupId = group
      url: '/membertransactions',
      abstract: true,
      template: '<ui-view />'
    })
    .state('group.memberView.memberTransaction.list', {
      url: '',
      template: listTemplate,
      controller: 'MemTransactionListCtrl',
      controllerAs: 'mtvm',
      authenticate: true
    })
    .state('group.memberView.memberTransaction.new', {
      url: '/new',
      template: formTemplate,
      controller: 'MemTransactionFormCtrl',
      controllerAs: 'mtvm',
      authenticate: true
    })
    .state('group.memberView.memberTransaction.view', {
      url: '/:mtId',
      template: viewTemplate,
      controller: 'MemTransactionViewCtrl',
      controllerAs: 'mtvm',
      authenticate: true
    })
    .state('group.memberView.memberTransaction.edit', {
      url: '/:mtId/edit',
      template: formTemplate,
      controller: 'MemTransactionFormCtrl',
      controllerAs: 'mtvm',
      authenticate: true
    });
}];
